import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import axiosInstance from "../../api/axiosInstance";

export default function UserList() {
  const [doctorSlots, setDoctorSlots] = useState<any>([]);
  const [loading, setLoading] = useState(true);

  // Fetch users
  useEffect(() => {
    const fetchDoctorSlots = async () => {
      try {
        const res = await axiosInstance.get("/admin/doctors/weekly-schedule");
        console.log(res.data);
        setDoctorSlots(res.data || []);
      } catch (err) {
        console.error("Failed to fetch users:", err);
        toast.error("Failed to fetch users.");
      } finally {
        setLoading(false);
      }
    };
    fetchDoctorSlots();
  }, []);



  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen text-gray-500">
        Loading Doctor Slots...
      </div>
    );
  }
  const groupedDoctorSlots = doctorSlots?.doctors.reduce(
    (acc: any, doctor: any) => {
      if (doctor?.appointments?.length) {
        doctor.appointments.forEach((appointment: any) => {
          const date = appointment.date || "Unknown Date";
          if (!acc[date]) {
            acc[date] = [];
          }
          acc[date].push({ ...appointment, name: doctor.name, specialisation: doctor.specialisation, profile: doctor.profile, phone: doctor.phone });
        });
      }
      return acc;
    },
    {}
  );
  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-6xl mx-auto bg-white shadow-md rounded-xl p-6">
        <h2 className="text-2xl font-bold text-gray-800 mb-4">
          📅 Appointment List {doctorSlots.from} - {doctorSlots.to}
        </h2>

        {Array.isArray(doctorSlots?.doctors) && doctorSlots?.doctors?.length > 0 ? (
          <div className="overflow-x-auto">
            <table className="min-w-full border border-gray-200 rounded-lg overflow-hidden">
              <thead className="bg-indigo-100">
                <tr>
                  <th className="px-6 py-3 text-left text-sm font-semibold text-gray-700">Profile</th>
                  <th className="px-6 py-3 text-left text-sm font-semibold text-gray-700">Doctor Name</th>
                  <th className="px-6 py-3 text-left text-sm font-semibold text-gray-700">Phone</th>
                  <th className="px-6 py-3 text-left text-sm font-semibold text-gray-700">Date</th>
                  <th className="px-6 py-3 text-left text-sm font-semibold text-gray-700">Slot Time</th>
                  <th className="px-6 py-3 text-left text-sm font-semibold text-gray-700">Available Slots</th>
                  <th className="px-6 py-3 text-center text-sm font-semibold text-gray-700">Specialisation</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {Object.entries(groupedDoctorSlots || {}).map(
                  ([date, doctorSlots]: any) => (
                    <React.Fragment key={date}>

                      {/* Date Header Row */}
                      <tr className="bg-gray-100">
                        <td
                          colSpan={7}
                          className="px-6 py-2 text-sm font-semibold text-gray-700"
                        >
                          {date}
                        </td>
                      </tr>

                      {/* Appointments for that Date */}
                      {doctorSlots.map((doctor: any) => (
                        <tr key={doctor.phone} className="hover:bg-gray-50">
                          <td className="px-6 py-3">
                            <img
                              src={doctor.profile}
                              alt={doctor.name}
                              className="w-12 h-12 rounded-full object-cover border"
                            />
                          </td>
                          <td className="px-6 py-3 text-gray-800">
                            {doctor.name || "—"}
                          </td>
                          <td className="px-6 py-3 text-gray-800">
                            {doctor.phone || "—"}
                          </td>
                          <td className="px-6 py-3 text-gray-800">
                            {doctor.date || "—"}
                          </td>
                          <td className="px-6 py-3 text-gray-600">
                            {doctor.startTime} - {doctor.endTime}
                          </td>
                          <td className="px-6 py-3 text-gray-600">
                            {doctor.availableSlots}
                          </td>
                          <td className="px-6 py-3 text-center">
                            {doctor.specialisation}
                          </td>
                        </tr>
                      ))}
                    </React.Fragment>
                  )
                )}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="text-gray-500 text-center py-6">No appointment found.</p>
        )}
      </div>
    </div>
  );
}
